import React from 'react'
import SignupPage from 'src/app/Signup/SignupPage'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { signupRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const SignupAppRoute: AppRoute = {
  id: AppLocation.Signup,
  routeProps: signupRouteProps,
  component: <SignupPage />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default SignupAppRoute
